// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1o7iA","requiredAsterisk":"Info_requiredAsterisk__3w8zk"};